import BoxImg from "../../../components/Cards/BoxImg"
import Titles from "../../../components/Titles/Titles"
import { responsivePadding, responsivePaddingLeft } from "../../../layouts/ResponsiveContainer"
import Button from "../../../components/Buttons/Button"
import { MdArrowForward } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom"
import { OdsPriorityGroups, OdsPriorityGroupsWithGrouped } from "../../../interfaces/ODSPriorityGroups"
import ods_img from '../../../assets/img/ods.png'
import groups from '../../../assets/img/groups.png'
const { REACT_APP_BACKOFFICE_CONNECTION, REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH } = process.env;

interface AccessGroupProps {
    title: string;
    iconData: OdsPriorityGroups[];
    containerClassName?: string;
    imageSrc: string;
    labelButton: string;
    basePath: string;
    onClick: () => void;
    period: string;
}

const AccessGroup = ({ title, iconData, containerClassName = "flex overflow-x-auto md:overflow-x-hidden", imageSrc, labelButton, basePath, onClick, period }: AccessGroupProps) => {
    return (
        <div className="mt-8 sm:mt-10">
            <div className={`flex justify-between items-center mb-6 ${responsivePadding}`}>
                <img src={imageSrc} alt={title.toLocaleLowerCase()} className="w-[3.148125rem] h-[2.5rem] hidden md:block object-contain mr-2" />
                <h2 className="text-tintermedium md:text-hsmall text-primary-10 w-full">{title}</h2>
                {iconData.length > 3
                    ? <div className="w-full flex justify-end">
                        <Button
                            label={labelButton}
                            showIconRight={false}
                            showIconLeft={false}
                            icon={MdArrowForward}
                            variant="terciary"
                            onClick={onClick}
                        />
                    </div>
                    : <></>
                }
            </div>
            <div className={`${containerClassName} ${responsivePaddingLeft} ${iconData.length > 5 ? 'overflow-x-scroll md:overflow-visible scrollbar-hide' : ''}`}>
                {iconData.slice(0, 5).map((item, index, arr) => (
                    <Link
                        key={index}
                        to={`${basePath}/${item.id}?period=${period}`}
                        className={`group w-[9.3125rem] md:w-[10.1125rem] lg:min-w-[10.4rem] xl:w-[13.5rem] h-[10.75rem] rounded-sm transition-all duration-200 ${index !== arr.length - 1 ? 'mr-3' : ''}`}
                    >
                        <div className="w-full h-full">
                            <BoxImg
                                icono={`${REACT_APP_BACKOFFICE_CONNECTION}/${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}/${item.imagen.replace("files/", "")}`}
                                alt={item.nombre}
                                variant="brand"
                                classImg="group-hover:scale-110 group-hover:brightness-105 group-hover:saturate-125 transition-all duration-700"
                            />
                        </div>
                    </Link>
                ))}
                <div className="w-[calc((100vw-20.5rem)/2)] sm:w-[calc((100vw-33.5rem)/2)] md:hidden flex-shrink-0" />
            </div>
        </div>
    );
};

interface TransversalApproachesProps {
    ods: OdsPriorityGroups[],
    priorityGroups: OdsPriorityGroupsWithGrouped[],
    period: string,
}

const TransversalApproaches = ({ ods, priorityGroups, period }: TransversalApproachesProps) => {
    const navigate = useNavigate();

    if (!ods.length && !priorityGroups.length) return null;

    return (
        <section className="w-full flex flex-col mt-12 lg:mt-13 bg-brand-baige-5 pt-[3.25rem] md:pt-10 pb-[3.25rem] md:pb-13">
            <div className={`${responsivePadding}`}>
                <Titles
                    title="Enfoques transversales"
                    withBgPattern={false}
                    color='text-brand-green-20'
                />
            </div>
            {priorityGroups.length > 0 && (
                <AccessGroup
                    title="Grupos prioritarios"
                    imageSrc={groups}
                    iconData={priorityGroups}
                    labelButton="Ver todos"
                    basePath="grupos-prioritarios"
                    onClick={() => navigate(`grupos-prioritarios/1?period=${period}`)}
                    period={period}
                />
            )}
            {ods.length > 0 && (
                <AccessGroup
                    title="ODS"
                    imageSrc={ods_img}
                    iconData={ods}
                    labelButton="Ver todos"
                    basePath="ods"
                    onClick={() => navigate(`ods/1?period=${period}`)}
                    period={period}
                />
            )}
        </section>
    );
};

export default TransversalApproaches